import styled from "styled-components";
import { device } from "../../config/sizes";
import { appColors } from "../../config/colors";

export const GridWrapper = styled.div<{
  isMainView: boolean;
  position: string;
}>`
  display: flex;
  flex-direction: row;
  width: 100vw;
  overflow-x: none;
  transform: translateX(
    ${({ isMainView, position }) =>
      isMainView ? 0 : position == "left" ? "100vw" : "-100vw"}
  );
  will-change: transform;
  transition: transform 1s ease;
  position: fixed;
`;

export const Page = styled.article`
  height: 100vh;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  overflow-y: scroll;
  overflow-x: hidden;

  @media ${device.mobile} {
    scroll-snap-type: none;
  }
`;

export const SectionWrapper = styled.section<{
  backgroundColor?: string;
  zIndex?: string;
}>`
  position: relative;
  z-index: ${({ zIndex }) => zIndex || 0};
  width: 100vw;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || appColors.backgroundPrimary};
  scroll-snap-align: start;
  
  video {
    width: 85%;
    padding: 5vh 0 5vh 0;
    align-self: center;
    justify-self:center
  }

  @media ${device.mobile} {
    h1,
    h2,
    h3 {
      line-height: 1.2;
    }

    video {
      width: 100%;
      justify-self: center;
      align-self: center;
    }
  }

  @media ${device.tablet} {
    h1,
    h2,
    h3 {
      line-height: 1.2;
    }

    video {
      width: 100%;
      justify-self: center;
      align-self: center;
    }
  }
`;

export const BackgroundImage = styled.div<{ src?: string }>`
  position: absolute;
  top: 15vh;
  background-image: url(${({ src }) => src && src});
  height: 70vh;
  width: 100vw;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: contain; /* Resize the background image to cover the entire container */
`;
